/* =============================================================================
   MELINAVA Survey Popup  v1.0
   -----------------------------------------------------------------------------
   Ablauf:  E-Mail  ->  1-2 Produktfragen  ->  Rabattcode
   Jede Antwort geht sofort nach Klaviyo (Event + Profilfeld), damit auch
   abgebrochene Surveys auswertbar bleiben.

   Abhaengigkeiten: keine. Vanilla JS, CSS wird injiziert.
   Voraussetzung:   survey-config.js muss VOR dieser Datei geladen werden.
   ========================================================================== */
(function () {
  'use strict';

  /* --- Einstellungen -------------------------------------------------- */
  var DEFAULTS = {
    publicKey: '',                 // Klaviyo Public API Key (Site ID)
    listId: '',                    // Klaviyo Liste fuer Popup-Anmeldungen
    revision: '2026-07-15',        // gepinnte Klaviyo API-Revision
    discountCode: 'WILLKOMMEN15',
    discountValue: '15%',
    doubleOptIn: true,             // true = Code kommt per Mail (DE-Pflichtweg)
    trigger: { delay: 8000, scroll: 45, exitIntent: true },
    frequencyDays: 30,
    textMaxLength: 300,            // harte Grenze fuer Freitextfelder
    excludePaths: ['/cart', '/checkout', '/account', '/pages/datenschutz'],
    privacyUrl: '/policies/privacy-policy',
    dryRun: false,                 // true = nichts senden, nur console.log

    // --- Inline-Modus (gehostete Umfrageseite) ------------------------
    // inline: CSS-Selektor eines Containers. Ist er gesetzt, rendert das
    // Widget in diesen Container statt als Overlay: keine Trigger, keine
    // Sperrfrist, kein Schliessen-Button.
    inline: '',
    // URL-Parameter mit der in der Mail geklickten Antwort auf Frage 1
    preAnswerParam: 'a'
  };

  var S = Object.assign({}, DEFAULTS, window.MELINAVA_SURVEY_SETTINGS || {});
  S.trigger = Object.assign({}, DEFAULTS.trigger, (window.MELINAVA_SURVEY_SETTINGS || {}).trigger || {});

  /* --- Oberflaechen-Texte --------------------------------------------- */
  var COPY = {
    de: {
      // Zielgruppe DE 50+: durchgehend Sie, passend zum Brand Kit
      // ("Ihr Weg zu natuerlicher Gesundheit").
      emailHeadline: 'Sichern Sie sich ' + S.discountValue + ' auf Ihre erste Bestellung',
      emailSub: 'Zwei kurze Fragen, dann gehört der Code Ihnen.',
      emailPlaceholder: 'Ihre E-Mail-Adresse',
      emailCta: 'Weiter',
      emailError: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
      consent: 'Ich möchte Produkt-Tipps und Angebote per E-Mail erhalten. Meine Antworten dürfen für persönliche Empfehlungen gespeichert werden. Abmeldung jederzeit möglich.',
      // Fallback auf der Umfrageseite: hier wird KEIN Newsletter-Consent
      // eingeholt, die Adresse dient allein der Zuordnung der Antworten.
      surveyEmailHeadline: 'Fast geschafft',
      surveyEmailSub: 'Wir konnten Sie nicht automatisch zuordnen. Bitte tragen Sie die Adresse ein, an die wir die Mail geschickt haben.',
      surveyConsent: 'Ihre Adresse dient ausschließlich dazu, Ihre Antworten Ihrer Bestellung zuzuordnen. Sie werden dadurch keinem Newsletter hinzugefügt.',
      privacy: 'Datenschutz',
      skip: 'Überspringen',
      back: 'Zurück',
      next: 'Weiter',
      multiHint: 'Wählen Sie alles aus, was zutrifft.',
      textPlaceholder: 'Schreiben Sie einfach frei heraus.',
      otherPlaceholder: 'Was genau denn?',
      doneHeadline: 'Geschafft.',
      doneSubDoi: 'Ihr Code liegt in Ihrem Postfach. Kurz bestätigen, dann können Sie ihn direkt einlösen.',
      doneSubDirect: 'Hier ist Ihr persönlicher Code:',
      thanks: 'Danke, das hilft uns wirklich weiter.',
      copy: 'Code kopieren',
      copied: 'Kopiert',
      shop: 'Jetzt einlösen',
      close: 'Schließen'
    },
    en: {
      emailHeadline: 'Get ' + S.discountValue + ' off your first order',
      emailSub: 'Two quick questions and the code is yours.',
      emailPlaceholder: 'Your email address',
      emailCta: 'Continue',
      emailError: 'Please enter a valid email address.',
      consent: 'I want to receive product tips and offers by email. My answers may be stored for personal recommendations. Unsubscribe anytime.',
      surveyEmailHeadline: 'Almost there',
      surveyEmailSub: 'We could not identify you automatically. Please enter the address we sent the email to.',
      surveyConsent: 'Your address is used solely to match your answers to your order. You will not be added to any newsletter.',
      privacy: 'Privacy',
      skip: 'Skip',
      back: 'Back',
      next: 'Continue',
      multiHint: 'Select all that apply.',
      textPlaceholder: 'Just write freely.',
      otherPlaceholder: 'What exactly?',
      doneHeadline: 'All set.',
      doneSubDoi: 'Your code is in your inbox. Confirm it and you are good to go.',
      doneSubDirect: 'Here is your personal code:',
      thanks: 'Thank you, that genuinely helps.',
      copy: 'Copy code',
      copied: 'Copied',
      shop: 'Redeem now',
      close: 'Close'
    }
  };

  /* --- Kontext erkennen ------------------------------------------------ */
  function detectLocale() {
    var l = window.MELINAVA_SURVEY_LOCALE
      || (window.Shopify && window.Shopify.locale)
      || document.documentElement.lang
      || 'de';
    return String(l).slice(0, 2).toLowerCase();
  }

  function detectHandle() {
    if (window.MELINAVA_SURVEY_PRODUCT) return window.MELINAVA_SURVEY_PRODUCT;
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : 'default';
  }

  var LOCALE, HANDLE, T, SURVEY;

  function resolveSurvey() {
    var all = window.MELINAVA_SURVEYS || {};
    var pack = all[LOCALE] || {};
    var fallback = all.de || {};
    return pack[HANDLE] || fallback[HANDLE] || pack.default || fallback.default || null;
  }

  // Kontext neu setzen. Ohne Argumente aus URL / Shopify-Globals gelesen.
  // Nuetzlich fuer SPA-Themes, Quick-View und die Vorschau-Seite.
  function applyContext(handle, locale) {
    HANDLE = handle || detectHandle();
    LOCALE = locale || detectLocale();
    T = COPY[LOCALE] || COPY.de;
    SURVEY = resolveSurvey();
    if (state && !state.open) { state.step = 'email'; state.answers = {}; }
    return !!SURVEY;
  }

  if (!applyContext()) return;

  /* --- Speicher -------------------------------------------------------- */
  var LS = {
    get: function (k) { try { return window.localStorage.getItem('mlv_' + k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem('mlv_' + k, v); } catch (e) {} }
  };

  /* --- Klaviyo --------------------------------------------------------- */
  var KL = {
    post: function (path, body) {
      if (S.dryRun) { console.log('[MLV dryRun] ' + path, body); return Promise.resolve(); }
      if (!S.publicKey) { console.warn('[MLV] publicKey fehlt'); return Promise.resolve(); }
      return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(S.publicKey), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: S.revision },
        body: JSON.stringify(body),
        keepalive: true
      }).catch(function (e) { console.warn('[MLV] Klaviyo ' + path + ' fehlgeschlagen', e); });
    },

    subscribe: function (email) {
      var attrs = {
        custom_source: 'Survey Popup: ' + HANDLE,
        profile: {
          data: {
            type: 'profile',
            attributes: {
              email: email,
              subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
            }
          }
        }
      };
      var data = { type: 'subscription', attributes: attrs };
      if (S.listId) data.relationships = { list: { data: { type: 'list', id: S.listId } } };
      return KL.post('subscriptions', { data: data });
    },

    profile: function (email, props, append) {
      var data = {
        type: 'profile',
        attributes: { email: email, properties: props }
      };
      if (append) data.meta = { patch_properties: { append: append } };
      return KL.post('profiles', { data: data });
    },

    event: function (email, metric, props) {
      return KL.post('events', {
        data: {
          type: 'event',
          attributes: {
            properties: props,
            metric: { data: { type: 'metric', attributes: { name: metric } } },
            profile: { data: { type: 'profile', attributes: { email: email } } }
          }
        }
      });
    },

    // Schreibweg fuer die gehostete Umfrageseite: dort kennen wir die
    // Adresse nicht, klaviyo.js haengt das Event an die Cookie-Identitaet,
    // die aus dem _kx-Parameter der Mail stammt.
    jsTrack: function (metric, props) {
      if (S.dryRun) { console.log('[MLV dryRun] klaviyo.js track', { metric: metric, properties: props }); return; }
      try {
        if (window.klaviyo && typeof window.klaviyo.push === 'function') {
          window.klaviyo.push(['track', metric, props]);
        } else if (window._learnq) {
          window._learnq.push(['track', metric, props]);
        } else {
          console.warn('[MLV] klaviyo.js nicht geladen, Event verworfen: ' + metric);
        }
      } catch (e) { console.warn('[MLV] klaviyo.js track fehlgeschlagen', e); }
    },

    identify: function (email) {
      // setzt das __kla_id Cookie -> spaetere Onsite-Events landen am Profil
      try {
        if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
          window.klaviyo.identify({ email: email });
        } else if (window._learnq) {
          window._learnq.push(['identify', { $email: email }]);
        }
      } catch (e) {}
    }
  };

  /* --- Status ---------------------------------------------------------- */

  // Kam der Besuch aus einer Klaviyo-Mail, hat das Onsite-Snippet den
  // _kx-Parameter bereits in eine Cookie-Identitaet aufgeloest. Dann
  // brauchen wir die Adresse nicht abzufragen.
  function detectIdentity() {
    if (!S.inline) return false;                    // im Popup wollen wir die Adresse
    if (window.MELINAVA_SURVEY_IDENTIFIED === true) return true;
    if (/[?&]_kx=/.test(window.location.search)) return true;
    return document.cookie.indexOf('__kla_id=') > -1;
  }

  var state = {
    // Rangfolge der Identitaet:
    //   1. Liquid bei eingeloggter Kundin (bester Fall: kein E-Mail-Schritt
    //      UND volle Profilfelder, ohne Adresse in irgendeiner URL)
    //   2. _kx aus der Mail, aufgeloest von klaviyo.js
    //   3. localStorage aus einer frueheren Popup-Anmeldung
    // Punkt 3 gilt NUR im Popup. Auf der gehosteten Umfrageseite waere eine
    // liegengebliebene Adresse gefaehrlich: auf einem geteilten Geraet
    // schriebe sie die Antworten ans falsche Profil.
    email: window.MELINAVA_SURVEY_EMAIL || (S.inline ? '' : LS.get('survey_email')) || '',
    identified: false,  // ueber klaviyo.js erkannt, Adresse unbekannt
    step: 'email',      // 'email' | 0..n-1 | 'done'
    answers: {},        // questionId -> { id, label, text }
    open: false
  };
  state.identified = detectIdentity();

  // Der E-Mail-Schritt entfaellt, wenn die Identitaet schon feststeht
  function needsEmailStep() { return !state.identified && !state.email; }

  // Events gehen ueber die Client-API, wenn wir die Adresse haben, sonst
  // ueber klaviyo.js. Profilfelder gehen nur mit Adresse, auf der
  // Umfrageseite wird stattdessen auf Event-Eigenschaften segmentiert.
  function trackEvent(metric, props) {
    if (state.email) return KL.event(state.email, metric, props);
    if (state.identified) return KL.jsTrack(metric, props);
    console.warn('[MLV] weder Adresse noch Identitaet, Event verworfen: ' + metric);
  }

  function writeProfile(props, append) {
    if (!state.email) return;
    KL.profile(state.email, props, append);
  }

  function baseProps() {
    return {
      survey_id: SURVEY.surveyId,
      product_handle: HANDLE,
      locale: LOCALE,
      page_url: window.location.href
    };
  }

  /* --- Schreib-Vorgaenge ----------------------------------------------- */
  function saveEmail(email) {
    state.email = email;
    LS.set('survey_email', email);
    KL.identify(email);
    // Nur das Popup ist ein Anmeldeformular. Auf der Umfrageseite waere ein
    // Marketing-Consent nicht gedeckt: die Person fuellt eine Umfrage aus,
    // sie abonniert nichts.
    if (!SURVEY.thanksOnly) KL.subscribe(email);
    KL.profile(email, Object.assign(baseProps(), {
      popup_source: 'survey_popup',
      last_survey_product: HANDLE,
      last_survey_at: new Date().toISOString()
    }));
    trackEvent('Survey Started', baseProps());
  }

  // text ist nur bei "Sonstiges"-Optionen gesetzt. Beides laeuft bewusst in
  // EINEM Profile-Write und EINEM Event, sonst wuerden sich die zwei Calls um
  // dasselbe Feld streiten und die Answered-Zaehlung doppelt hochgehen.
  function saveAnswer(question, option, text) {
    text = text ? String(text).trim().slice(0, S.textMaxLength) : '';
    state.answers[question.id] = { id: option.id, label: option.label, text: text };

    var props = {};
    props[option.id] = true;                         // Segmentierungs-Flag
    props['answer_' + question.id] = option.label;   // lesbar im Klaviyo-Profil
    props.last_survey_product = HANDLE;
    props.last_survey_at = new Date().toISOString();

    var append = null;
    if (text) {
      props['answer_' + question.id + '_text'] = text;
      append = { survey_notes: HANDLE + ': ' + text };
    }

    writeProfile(props, append);
    trackEvent('Survey Answered', Object.assign(baseProps(), {
      question_id: question.id,
      question: question.headline,
      answer_id: option.id,
      answer: option.label,
      answer_text: text,
      shown_position: state.position || 0
    }));
  }

  // Mehrfachauswahl. Wie bei saveAnswer laufen alle gewaehlten Optionen in
  // EINEM Profile-Write und EINEM Event zusammen: jede Option setzt weiter
  // ihr eigenes Boolean-Flag (Segmente aus Einfachauswahl-Zeiten passen
  // damit unveraendert), das lesbare Feld traegt alle Labels, und die
  // Answered-Zaehlung geht pro Frage genau einmal hoch.
  function saveMulti(question, options, text) {
    text = text ? String(text).trim().slice(0, S.textMaxLength) : '';
    var ids = options.map(function (o) { return o.id; });
    var labels = options.map(function (o) { return o.label; }).join(', ');
    state.answers[question.id] = { id: ids, label: labels, text: text };

    var props = {};
    options.forEach(function (o) { props[o.id] = true; });
    props['answer_' + question.id] = labels;
    props.last_survey_product = HANDLE;
    props.last_survey_at = new Date().toISOString();

    var append = null;
    if (text) {
      props['answer_' + question.id + '_text'] = text;
      append = { survey_notes: HANDLE + ': ' + text };
    }

    writeProfile(props, append);
    trackEvent('Survey Answered', Object.assign(baseProps(), {
      question_id: question.id,
      question: question.headline,
      answer_ids: ids,
      answer: labels,
      answer_text: text,
      answer_count: ids.length
    }));
  }

  // Freitext. Bewusst KEIN Boolean-Feld: der Wert ist unvorhersehbar und
  // taugt nicht zur Segmentierung. Stattdessen als Klartext aufs Profil und
  // zusaetzlich an die Liste "survey_notes" angehaengt, damit frueherer Text
  // beim naechsten Produkt nicht ueberschrieben wird.
  function saveText(question, text) {
    text = String(text).trim().slice(0, S.textMaxLength);
    if (!text) return;

    state.answers[question.id] = { id: 'freitext_' + question.id, label: text, text: text };

    var props = {};
    props['answer_' + question.id] = text;
    props.last_survey_product = HANDLE;
    props.last_survey_at = new Date().toISOString();

    writeProfile(props, { survey_notes: HANDLE + ': ' + text });
    trackEvent('Survey Answered', Object.assign(baseProps(), {
      question_id: question.id,
      question: question.headline,
      answer_text: text,
      is_free_text: true
    }));
  }

  function saveComplete() {
    var ids = [], labels = {};
    Object.keys(state.answers).forEach(function (q) {
      var a = state.answers[q];
      ids = ids.concat(a.id);             // concat statt push: Mehrfachauswahl liefert Arrays
      // Freitext haengt sichtbar an der gewaehlten Option, damit ein einziges
      // Completed-Event das ganze Bild enthaelt
      labels[q] = (a.text && a.text !== a.label) ? a.label + ': ' + a.text : a.label;
    });

    trackEvent('Survey Completed', Object.assign(baseProps(), {
      answer_ids: ids,
      answers: labels,
      answer_count: ids.length,
      discount_code: SURVEY.thanksOnly ? '' : S.discountCode
    }));

    var append = null;
    if (!LS.get('surveyed_' + HANDLE)) {
      append = { surveyed_products: HANDLE };
      LS.set('surveyed_' + HANDLE, '1');
    }
    // ohne Rabatt auch kein Code aufs Profil
    var props = SURVEY.thanksOnly ? {} : { popup_discount_code: S.discountCode };
    if (append || !SURVEY.thanksOnly) writeProfile(props, append);
  }

  /* --- Styles ---------------------------------------------------------- */
  var CSS = [
    '.mlv-ov{position:fixed;inset:0;z-index:2147483000;background:rgba(26,24,21,.55);',
    'display:flex;align-items:center;justify-content:center;padding:20px;',
    'opacity:0;transition:opacity .25s ease;font-family:inherit}',
    '.mlv-ov.is-on{opacity:1}',
    '.mlv-box{position:relative;width:100%;max-width:440px;background:#faf8f4;color:#1a1815;',
    'border-radius:20px;padding:36px 30px 26px;box-shadow:0 24px 60px rgba(26,24,21,.28);',
    'transform:translateY(14px);transition:transform .25s ease;max-height:92vh;overflow-y:auto}',
    '.mlv-ov.is-on .mlv-box{transform:none}',
    '.mlv-x{position:absolute;top:12px;right:12px;width:34px;height:34px;border:0;background:none;',
    'font-size:22px;line-height:1;color:#b8aa92;cursor:pointer;border-radius:50%}',
    '.mlv-x:hover{background:#ede8df;color:#6b6256}',
    '.mlv-dots{display:flex;gap:6px;justify-content:center;margin-bottom:20px}',
    '.mlv-dot{width:26px;height:3px;border-radius:2px;background:#ede8df}',
    '.mlv-dot.on{background:#6e5c43}',
    '.mlv-h{font-size:23px;line-height:1.25;font-weight:700;margin:0 0 8px;text-align:center;letter-spacing:-.01em}',
    '.mlv-sub{font-size:14px;line-height:1.5;color:#6b6256;margin:0 0 20px;text-align:center}',
    '.mlv-in{width:100%;box-sizing:border-box;padding:15px 16px;font-size:16px;font-family:inherit;',
    'border:1.5px solid #d4cec3;border-radius:12px;background:#fff;color:#1a1815;outline:none}',
    '.mlv-in:focus{border-color:#6e5c43}',
    '.mlv-in.err{border-color:#b03a2e}',
    '.mlv-msg{font-size:13px;color:#b03a2e;margin:8px 2px 0;display:none}',
    '.mlv-msg.on{display:block}',
    '.mlv-cta{width:100%;margin-top:12px;padding:16px;font-size:16px;font-weight:700;font-family:inherit;',
    'color:#faf8f4;background:#1a1815;border:0;border-radius:12px;cursor:pointer;transition:background .18s}',
    '.mlv-cta:hover{background:#6e5c43}',
    '.mlv-cta[disabled]{opacity:.6;cursor:default}',
    '.mlv-opts{display:flex;flex-direction:column;gap:9px}',
    '.mlv-opt{display:flex;align-items:center;gap:11px;width:100%;text-align:left;padding:15px 16px;',
    'font-size:15px;font-family:inherit;font-weight:600;color:#1a1815;background:#fff;',
    'border:1.5px solid #ede8df;border-radius:12px;cursor:pointer;transition:border-color .15s,transform .1s}',
    '.mlv-opt:hover{border-color:#b8aa92;transform:translateY(-1px)}',
    '.mlv-opt.sel{border-color:#6e5c43;background:#f3efe7}',
    '.mlv-emo{font-size:19px;line-height:1;flex:0 0 auto}',
    '.mlv-ta{width:100%;box-sizing:border-box;padding:14px 16px;font-size:16px;font-family:inherit;',
    'line-height:1.5;border:1.5px solid #d4cec3;border-radius:12px;background:#fff;color:#1a1815;',
    'outline:none;resize:none}',
    '.mlv-ta:focus{border-color:#6e5c43}',
    '.mlv-count{text-align:right;font-size:11px;color:#b8aa92;margin:6px 2px 0}',
    '.mlv-other{margin-top:9px}',
    // Einwilligungstext muss lesbar sein, daher bewusst kein helles Grau
    '.mlv-foot{margin-top:16px;text-align:center;font-size:12px;line-height:1.5;color:#6b6256}',
    '.mlv-foot a{color:#6e5c43}',
    '.mlv-skip{display:block;margin:14px auto 0;background:none;border:0;font-family:inherit;',
    'font-size:13px;color:#b8aa92;text-decoration:underline;cursor:pointer}',
    '.mlv-code{margin:18px 0 4px;padding:16px;text-align:center;font-size:22px;font-weight:800;',
    'letter-spacing:.09em;background:#fff;border:1.5px dashed #b8aa92;border-radius:12px}',
    // Inline: gehostete Umfrageseite, kein Overlay drumherum
    '.mlv-inline{margin:0 auto;max-width:520px;box-shadow:none;border:1px solid #ede8df;',
    'transform:none;max-height:none;overflow:visible;padding:40px 34px 30px}',
    '@media(max-width:560px){',
    '.mlv-ov{align-items:flex-end;padding:0}',
    '.mlv-box{max-width:none;border-radius:20px 20px 0 0;padding:30px 20px 22px;max-height:88vh}',
    '.mlv-inline{border-radius:18px;padding:28px 20px 24px;max-height:none}',
    '.mlv-h{font-size:21px}}'
  ].join('');

  function injectCss() {
    if (document.getElementById('mlv-survey-css')) return;
    var s = document.createElement('style');
    s.id = 'mlv-survey-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  /* --- Rendering ------------------------------------------------------- */
  var ov, box, lastFocus;

  function esc(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function totalSteps() { return SURVEY.questions.length + (needsEmailStep() ? 1 : 0); }

  // Im Inline-Modus gibt es nichts zu schliessen
  function closeBtn() {
    return S.inline ? ''
      : '<button class="mlv-x" aria-label="' + esc(T.close) + '">&times;</button>';
  }

  // Ohne E-Mail-Schritt verschiebt sich die Punktleiste um eins nach vorn
  function stepDot(idx) { return needsEmailStep() ? idx + 1 : idx; }

  function dots(active) {
    var out = '<div class="mlv-dots">';
    for (var i = 0; i < totalSteps(); i++) {
      out += '<span class="mlv-dot' + (i <= active ? ' on' : '') + '"></span>';
    }
    return out + '</div>';
  }

  function render() {
    if (state.step === 'email') return renderEmail();
    if (state.step === 'done') return renderDone();
    return renderQuestion(SURVEY.questions[state.step], state.step);
  }

  function renderEmail() {
    // Forschungsumfrage statt Lead-Formular: andere Headline, anderer
    // Einwilligungstext, kein Rabattversprechen.
    var isSurvey = !!SURVEY.thanksOnly;

    box.innerHTML =
      closeBtn() +
      dots(0) +
      '<h2 class="mlv-h">' + esc(isSurvey ? T.surveyEmailHeadline : T.emailHeadline) + '</h2>' +
      '<p class="mlv-sub">' + esc(isSurvey ? T.surveyEmailSub : T.emailSub) + '</p>' +
      '<form novalidate>' +
      '<input class="mlv-in" type="email" name="email" autocomplete="email" inputmode="email" ' +
      'placeholder="' + esc(T.emailPlaceholder) + '" value="' + esc(state.email) + '">' +
      '<p class="mlv-msg">' + esc(T.emailError) + '</p>' +
      '<button class="mlv-cta" type="submit">' + esc(T.emailCta) + '</button>' +
      '</form>' +
      '<p class="mlv-foot">' + esc(isSurvey ? T.surveyConsent : T.consent) +
      ' <a href="' + esc(S.privacyUrl) + '" target="_blank" rel="noopener">' + esc(T.privacy) + '</a></p>';

    var form = box.querySelector('form');
    var input = box.querySelector('.mlv-in');
    var msg = box.querySelector('.mlv-msg');

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = input.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) {
        input.classList.add('err');
        msg.classList.add('on');
        input.focus();
        return;
      }
      saveEmail(v);
      state.step = 0;
      render();
    });

    input.addEventListener('input', function () {
      input.classList.remove('err');
      msg.classList.remove('on');
    });

    setTimeout(function () { if (window.innerWidth > 560) input.focus(); }, 120);
  }

  // gemeinsamer Kopf fuer alle Fragetypen
  function questionHead(q, idx) {
    return closeBtn() +
      dots(stepDot(idx)) +
      '<h2 class="mlv-h">' + esc(q.headline) + '</h2>' +
      (q.sub ? '<p class="mlv-sub">' + esc(q.sub) + '</p>' : '<div style="height:8px"></div>');
  }

  // Optionen weiter oben werden haeufiger geklickt. Bei einer Umfrage, die
  // Motive messen soll, verfaelscht das die Verteilung. shuffle: true mischt
  // pro Aufruf; Optionen mit fixed: true bleiben unten (Sammel- und
  // Sonstiges-Optionen gehoeren ans Ende, nicht in die Mitte).
  function orderedOptions(q) {
    if (!q.shuffle) return q.options;
    var loose = [], pinned = [];
    q.options.forEach(function (o) { (o.fixed ? pinned : loose).push(o); });
    for (var i = loose.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = loose[i]; loose[i] = loose[j]; loose[j] = tmp;
    }
    return loose.concat(pinned);
  }

  function renderQuestion(q, idx) {
    if (q.type === 'text') return renderText(q, idx);
    if (q.type === 'multi') return renderMulti(q, idx);

    var shown = orderedOptions(q);
    var opts = shown.map(function (o) {
      return '<button class="mlv-opt" type="button" data-id="' + esc(o.id) + '">' +
        (o.emoji ? '<span class="mlv-emo">' + o.emoji + '</span>' : '') +
        '<span>' + esc(o.label) + '</span></button>';
    }).join('');

    box.innerHTML =
      questionHead(q, idx) +
      '<div class="mlv-opts">' + opts + '</div>' +
      '<div class="mlv-other"></div>' +
      (q.optional ? '<button class="mlv-skip" type="button">' + esc(T.skip) + '</button>' : '');

    var other = box.querySelector('.mlv-other');

    box.querySelectorAll('.mlv-opt').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var option = q.options.filter(function (o) { return o.id === btn.dataset.id; })[0];
        box.querySelectorAll('.mlv-opt').forEach(function (b) { b.classList.remove('sel'); });
        btn.classList.add('sel');
        // Anzeigeposition mitschreiben, damit sich pruefen laesst, ob das
        // Mischen den Positionseffekt wirklich rausgenommen hat
        state.position = shown.indexOf(option) + 1;

        // "Sonstiges": Auswahl merken, aber statt weiterzuspringen ein
        // Textfeld aufklappen. Gespeichert wird dann beides.
        if (option.other) {
          other.innerHTML =
            '<textarea class="mlv-ta" rows="2" maxlength="' + S.textMaxLength + '" ' +
            'placeholder="' + esc(option.placeholder || T.otherPlaceholder) + '"></textarea>' +
            '<button class="mlv-cta" type="button">' + esc(T.next) + '</button>';
          var ta = other.querySelector('.mlv-ta');
          setTimeout(function () { ta.focus(); }, 60);
          other.querySelector('.mlv-cta').addEventListener('click', function () {
            saveAnswer(q, option, ta.value);
            advance();
          });
          return;
        }

        other.innerHTML = '';
        saveAnswer(q, option);
        setTimeout(advance, 180);            // kurzes Feedback vor dem Wechsel
      });
    });

    var skip = box.querySelector('.mlv-skip');
    if (skip) skip.addEventListener('click', advance);
  }

  // Mehrfachauswahl: Optionen schalten um statt sofort zu speichern,
  // abgeschickt wird erst mit "Weiter". Ohne eigene Unterzeile erklaert eine
  // Standardzeile, dass mehrere Antworten erlaubt sind — den Buttons sieht
  // man das sonst nicht an.
  function renderMulti(q, idx) {
    var shown = orderedOptions(q);
    var opts = shown.map(function (o) {
      return '<button class="mlv-opt" type="button" aria-pressed="false" data-id="' + esc(o.id) + '">' +
        (o.emoji ? '<span class="mlv-emo">' + o.emoji + '</span>' : '') +
        '<span>' + esc(o.label) + '</span></button>';
    }).join('');

    var head = q.sub ? q : Object.assign({}, q, { sub: T.multiHint });

    box.innerHTML =
      questionHead(head, idx) +
      '<div class="mlv-opts">' + opts + '</div>' +
      '<div class="mlv-other"></div>' +
      '<button class="mlv-cta" type="button" disabled>' + esc(T.next) + '</button>' +
      (q.optional ? '<button class="mlv-skip" type="button">' + esc(T.skip) + '</button>' : '');

    var other = box.querySelector('.mlv-other');
    var cta = box.querySelector('.mlv-cta');
    var picked = {};                       // option.id -> option | null

    // Ausgabe in Anzeige-Reihenfolge, nicht in Klick-Reihenfolge: bei
    // shuffle waere die Klick-Reihenfolge pro Person verschieden und die
    // zusammengesetzten Labels liessen sich nicht mehr vergleichen.
    function selected() {
      return shown.filter(function (o) { return picked[o.id]; });
    }

    function sync() {
      var sel = selected();
      cta.disabled = sel.length === 0;
      var others = sel.filter(function (o) { return o.other; });
      if (!others.length) { other.innerHTML = ''; return; }
      if (!other.querySelector('.mlv-ta')) {
        other.innerHTML =
          '<textarea class="mlv-ta" rows="2" maxlength="' + S.textMaxLength + '" ' +
          'placeholder="' + esc(others[0].placeholder || T.otherPlaceholder) + '"></textarea>';
        var ta = other.querySelector('.mlv-ta');
        setTimeout(function () { ta.focus(); }, 60);
      }
    }

    box.querySelectorAll('.mlv-opt').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.dataset.id;
        picked[id] = picked[id] ? null
          : q.options.filter(function (o) { return o.id === id; })[0];
        btn.classList.toggle('sel', !!picked[id]);
        btn.setAttribute('aria-pressed', picked[id] ? 'true' : 'false');
        sync();
      });
    });

    // In der Mail vorgewaehlte Antwort markieren, aber nicht abschicken:
    // wer hier landet, soll weitere Antworten dazuwaehlen koennen.
    if (state.preSelect) {
      var pre = box.querySelector('.mlv-opt[data-id="' + state.preSelect + '"]');
      state.preSelect = null;
      if (pre) pre.click();
    }

    cta.addEventListener('click', function () {
      var sel = selected();
      if (!sel.length) return;
      var ta = other.querySelector('.mlv-ta');
      saveMulti(q, sel, ta ? ta.value : '');
      advance();
    });

    var skip = box.querySelector('.mlv-skip');
    if (skip) skip.addEventListener('click', advance);
  }

  function renderText(q, idx) {
    box.innerHTML =
      questionHead(q, idx) +
      '<textarea class="mlv-ta" rows="3" maxlength="' + S.textMaxLength + '" ' +
      'placeholder="' + esc(q.placeholder || T.textPlaceholder) + '"></textarea>' +
      '<p class="mlv-count">0/' + S.textMaxLength + '</p>' +
      '<button class="mlv-cta" type="button">' + esc(T.next) + '</button>' +
      (q.optional === false ? '' : '<button class="mlv-skip" type="button">' + esc(T.skip) + '</button>');

    var ta = box.querySelector('.mlv-ta');
    var count = box.querySelector('.mlv-count');

    ta.addEventListener('input', function () {
      count.textContent = ta.value.length + '/' + S.textMaxLength;
    });

    box.querySelector('.mlv-cta').addEventListener('click', function () {
      saveText(q, ta.value);               // leerer Text wird still verworfen
      advance();
    });

    var skip = box.querySelector('.mlv-skip');
    if (skip) skip.addEventListener('click', advance);

    setTimeout(function () { if (window.innerWidth > 560) ta.focus(); }, 120);
  }

  function advance() {
    if (state.step + 1 < SURVEY.questions.length) {
      state.step = state.step + 1;
    } else {
      state.step = 'done';
      saveComplete();
    }
    render();
  }

  function renderDone() {
    // Bestellerumfragen laufen ohne Rabatt: thanksOnly zeigt nur einen Dank
    var thanksOnly = !!SURVEY.thanksOnly;
    var showCode = !thanksOnly && !S.doubleOptIn;
    var sub = thanksOnly ? (SURVEY.thanksText || T.thanks)
      : (showCode ? T.doneSubDirect : T.doneSubDoi);

    box.innerHTML =
      closeBtn() +
      dots(totalSteps()) +
      '<h2 class="mlv-h">' + esc(T.doneHeadline) + '</h2>' +
      '<p class="mlv-sub">' + esc(sub) + '</p>' +
      (showCode
        ? '<div class="mlv-code">' + esc(S.discountCode) + '</div>' +
          '<button class="mlv-cta mlv-copy" type="button">' + esc(T.copy) + '</button>' +
          '<button class="mlv-skip mlv-shop" type="button">' + esc(T.shop) + '</button>'
        : S.inline ? ''
          : '<button class="mlv-cta mlv-close" type="button">' + esc(T.close) + '</button>');

    var copyBtn = box.querySelector('.mlv-copy');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        try { navigator.clipboard.writeText(S.discountCode); } catch (e) {}
        copyBtn.textContent = T.copied;
      });
    }
    var shopBtn = box.querySelector('.mlv-shop');
    if (shopBtn) {
      shopBtn.addEventListener('click', function () {
        window.location.href = '/discount/' + encodeURIComponent(S.discountCode) + '?redirect=/collections/all';
      });
    }
    var closeCta = box.querySelector('.mlv-close');
    if (closeCta) closeCta.addEventListener('click', close);
  }

  /* --- Auf/Zu ---------------------------------------------------------- */
  function open() {
    if (state.open) return;
    state.open = true;
    injectCss();
    if (S.inline) return mountInline();
    LS.set('survey_seen_at', String(Date.now()));

    lastFocus = document.activeElement;
    ov = document.createElement('div');
    ov.className = 'mlv-ov';
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-modal', 'true');
    box = document.createElement('div');
    box.className = 'mlv-box';
    ov.appendChild(box);
    document.body.appendChild(ov);
    document.body.style.overflow = 'hidden';

    render();
    // bewusst setTimeout statt requestAnimationFrame: rAF wird in inaktiven
    // Tabs gedrosselt, das Overlay bliebe dann auf opacity 0 stehen
    var opening = ov;
    setTimeout(function () { opening.classList.add('is-on'); }, 20);

    ov.addEventListener('click', function (e) {
      if (e.target === ov || e.target.classList.contains('mlv-x')) close();
    });
    document.addEventListener('keydown', onKey);
  }

  // Gehostete Umfrageseite: in einen Container rendern, kein Overlay,
  // kein Scroll-Lock, nichts zu schliessen.
  function mountInline() {
    var host = document.querySelector(S.inline);
    if (!host) { console.warn('[MLV] Container ' + S.inline + ' nicht gefunden'); return; }
    host.innerHTML = '';
    box = document.createElement('div');
    box.className = 'mlv-box mlv-inline';
    host.appendChild(box);

    // in der Mail geklickte Antwort auf Frage 1 uebernehmen
    consumePreAnswer();
    if (state.step === 'email' && !needsEmailStep()) state.step = 0;
    render();
  }

  // ?a=<antwort_id> aus dem Mail-Button. "Sonstiges"-Optionen werden bewusst
  // nicht vorbelegt, dort fehlt ja noch der Text.
  function consumePreAnswer() {
    if (!S.preAnswerParam) return;
    var m = new RegExp('[?&]' + S.preAnswerParam + '=([^&#]+)').exec(window.location.search);
    if (!m) return;
    var id = decodeURIComponent(m[1]);
    var q = SURVEY.questions[0];
    if (!q || !q.options) return;
    var opt = q.options.filter(function (o) { return o.id === id && !o.other; })[0];
    if (!opt) return;
    // Bei Mehrfachauswahl nur vorwaehlen: sofort speichern und springen
    // wuerde die Frage auf die eine Mail-Antwort verkuerzen.
    if (q.type === 'multi') { state.preSelect = opt.id; return; }
    state.position = 0;                       // Position kam aus der Mail
    saveAnswer(q, opt);
    state.step = SURVEY.questions.length > 1 ? 1 : 'done';
    if (state.step === 'done') saveComplete();
  }

  function onKey(e) { if (e.key === 'Escape') close(); }

  function close() {
    if (!state.open || S.inline) return;
    state.open = false;
    document.removeEventListener('keydown', onKey);
    document.body.style.overflow = '';
    var dying = ov;                       // Node festhalten: ov kann bis zum
    ov = null;                            // Timeout schon neu belegt sein
    dying.classList.remove('is-on');
    setTimeout(function () { if (dying.parentNode) dying.parentNode.removeChild(dying); }, 260);
    if (lastFocus && lastFocus.focus) lastFocus.focus();

    if ((state.email || state.identified) && state.step !== 'done') {
      trackEvent('Survey Abandoned', Object.assign(baseProps(), {
        abandoned_at_step: String(state.step)
      }));
    }
  }

  /* --- Trigger --------------------------------------------------------- */
  function suppressed() {
    if (window.MELINAVA_SURVEY_FORCE) return false;
    var path = window.location.pathname;
    for (var i = 0; i < S.excludePaths.length; i++) {
      if (path.indexOf(S.excludePaths[i]) === 0) return true;
    }
    if (LS.get('surveyed_' + HANDLE)) return true;
    var seen = parseInt(LS.get('survey_seen_at') || '0', 10);
    if (seen && Date.now() - seen < S.frequencyDays * 864e5) return true;
    return false;
  }

  function arm() {
    // Inline-Modus laeuft ohne Trigger und ohne Sperrfrist: die Seite IST
    // die Umfrage, wer hier ankommt, hat schon geklickt.
    if (S.inline) return open();
    if (suppressed()) return;
    var fired = false;
    function fire() {
      if (fired || suppressed()) return;
      fired = true;
      cleanup();
      open();
    }
    function onScroll() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && (window.scrollY / h) * 100 >= S.trigger.scroll) fire();
    }
    function onOut(e) {
      if (e.clientY <= 0 && !e.relatedTarget) fire();
    }
    function cleanup() {
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('mouseout', onOut);
      clearTimeout(timer);
    }
    var timer = setTimeout(fire, S.trigger.delay);
    if (S.trigger.scroll) window.addEventListener('scroll', onScroll, { passive: true });
    if (S.trigger.exitIntent) document.addEventListener('mouseout', onOut);
  }

  /* --- Oeffentliche API ------------------------------------------------ */
  window.MelinavaSurvey = {
    open: open,
    close: close,
    setContext: applyContext,
    current: function () { return { handle: HANDLE, locale: LOCALE, survey: SURVEY }; },
    reset: function () {
      try {
        Object.keys(window.localStorage)
          .filter(function (k) { return k.indexOf('mlv_') === 0; })
          .forEach(function (k) { window.localStorage.removeItem(k); });
      } catch (e) {}
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arm);
  } else {
    arm();
  }
})();
